import React from 'react';
import { FieldChangeGrid } from '@pages/admin/audit-log/change-grid';
import { getFieldChangeItemsAuditRecord, getProcessedFieldChangeItems } from '@pages/admin/audit-log/service';
import { datasetFilterValues } from '@components-clean/core/comparison-dataset-card/comparison-dataset-card.data';
import { useTranslation } from '@hooks/index';

interface RecordProps {
    DataSetFilter?: number;
    DataSetsCount?: number;
    AllowKRIReviews?: boolean;
    StudySiteMean?: boolean;
    StudyRate?: boolean;
}

interface StudyDashboardConfigAuditLogGridProps {
    oldRecord: RecordProps;
    newRecord: RecordProps;
    oldItem?: Record<string, unknown>;
    newItem?: Record<string, unknown>;
}

const StudyDashboardConfigAuditLogGrid = ({
    oldRecord,
    newRecord,
    oldItem,
    newItem,
}: StudyDashboardConfigAuditLogGridProps) => {
    const { t } = useTranslation();

    const refactorRecord = (record: RecordProps) => {
        return {
            DataSetFilter:
                record?.DataSetFilter !== undefined
                    ? (datasetFilterValues.find((item) => item.value === record?.DataSetFilter?.toString())?.text ?? '')
                    : record?.DataSetFilter,
            DataSetsCount: record.DataSetsCount,
            AllowKRIReviews: record.AllowKRIReviews,
            PanelLineCalculationSelection:
                record?.StudyRate !== undefined
                    ? record?.StudySiteMean
                        ? t('auditLog:field-StudySiteMean')
                        : t('auditLog:field-StudyRate')
                    : record?.StudyRate,
        };
    };

    const refactoredOldRecord = refactorRecord(oldRecord);
    const refactoredNewRecord = refactorRecord(newRecord);

    const items = getFieldChangeItemsAuditRecord(refactoredOldRecord, refactoredNewRecord, null, (field: string) => {
        getProcessedFieldChangeItems({
            oldRecord,
            newRecord,
            oldItem,
            newItem,
            field,
        });
    });

    return <FieldChangeGrid items={items} />;
};

export default StudyDashboardConfigAuditLogGrid;
